<template>
  <layout title="Anreise" :banner="$page.props.banner" h1="Anreise" metaDescription="Hier findest du alle Anreise-Informationen zu deinem Skiurlaub. Ob mit dem Bus, der Bahn, dem Schneebus, oder dem eigenen PKW. Wir freuen uns auf deinen Besuch."
    metaKeywords="SCOL, Über SCOL, SCOL Skireisen, Anreise, Bus, Bahn, Schneebus, PKW, Skireise Anreise, Anreise SCOL">
    <section id="anreise">
      <div id="info-tabs" class="scol-section bg-white">
        <div class="bg-light-grey">
          <div class="container">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#bus" type="button">
                  Bus
                </button>
              </li>
              <!-- <li class="nav-item" role="presentation">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#bahn" type="button">
                  Bahn
                </button>
              </li> -->
              <li class="nav-item" role="presentation">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#schneebus" type="button">
                  Schneebus
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#pkw" type="button">
                  Eigener PKW
                </button>
              </li>
              <!-- <li class="nav-item" role="presentation">
                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#abreise" type="button">
                  Abreiseinfos
                </button>
              </li> -->
            </ul>
          </div>
        </div>

        <div class="container tab-content">
          <div class="tab-pane fade show active pt-4 pt-mt-5" id="bus" role="tabpanel">
            <div class="row">
              <div class="col-md-4 order-1">
                <img class="w-100" src="images/scol-skireisen-anreise-bus.jpg" alt="Bus von Janssen Reisen" />
              </div>
              <div class="col-md-8 mt-4 order-2">
                <h3>Die Anreise mit dem Bus: Im Schlaf in den Urlaub</h3>
                <p>
                  Auf der Nordroute fahren wir (OL-HB-H) wieder mit den Top Premium Class Fernreisebussen u.a. der Firmen Janssen und Hilgen. Diese Busse bieten Ihnen ein Maximum an Freiraum und Bequemlichkeit. Der Sitzabstand beträgt ca. 15 cm mehr als in anderen Standard Class Bussen. Die Busse
                  (Nichtraucher) sind mit WC, Liegesessel, Kühlschrank und teilweise mit Bordbistro ausgestattet. Bordkomfort bis ins kleinste Detail macht jede lange Reise zu einem kurzweiligen Vergnügen.
                </p>
                <!-- <p>
                  <b>Neu im Winter 23/24:</b> wir bieten euch
                  Zustiegsmöglichkeiten in Vechta/Lohne an. An folgenden
                  Terminen ist dort der Zustieg möglich: 29.12. / 26.01./
                  01.03./ 15.03./ 22.03.
                </p> -->
              </div>
              <div class="col-md-6 order-4 pt-md-5 order-md-3">
                <table class="mb-3">
                  <tr>
                    <th>Nordroute</th>
                    <th>Zustiegsort</th>
                    <th>Uhrzeit</th>
                  </tr>
                  <tr>
                    <td class="pt-3">Oldenburg</td>
                    <td class="pt-3">ZOB beim Hauptbahnhof</td>
                    <td class="pt-3">19:30</td>
                  </tr>
                  <tr>
                    <td>Bremen</td>
                    <td>Neuer ZOB beim Hauptbahnhof, Rosa Parks Ring 11-15</td>
                    <td>20:15</td>
                  </tr>
                  <tr>
                    <td>Hannover</td>
                    <td>Raststätte Wülferode West, Tankstelle</td>
                    <td>22:00</td>
                  </tr>
                  <tr>
                    <td>Göttingen</td>
                    <td>Autobahnraststätte Göttingen West, Tankstelle</td>
                    <td>23:00</td>
                  </tr>
                  <tr>
                    <td>Kassel</td>
                    <td>Autobahnraststätte Kassel Ost, Lohfelden</td>
                    <td>00:15</td>
                  </tr>
                </table>

                <!-- Westroute -->
                <table class="mb-3">
                  <tr>
                    <th>Westroute</th>
                    <th>Zustiegsort</th>
                    <th>Uhrzeit</th>
                    <th>Zuschlag</th>
                  </tr>
                  <tr>
                    <td class="pt-3">Vechta</td>
                    <td class="pt-3">Autohof Bakum (ab 4 Personen)</td>
                    <td class="pt-3">Nach Absprache</td>
                    <td class="pt-3">45,- €</td>
                  </tr>
                  <tr>
                    <td>Osnabrück</td>
                    <td>Autohof Osnabrück Hafen (ab 4 Personen)</td>
                    <td>Nach Absprache</td>
                    <td>45,- €</td>
                  </tr>
                  <tr>
                    <td>Münster</td>
                    <td>Hbf., Hafenstraße</td>
                    <td>19:30</td>
                    <td>25,- €</td>
                  </tr>
                  <tr>
                    <td>Essen</td>
                    <td>Fernbusterminal am ZOB</td>
                    <td>21:00</td>
                    <td>25,- €</td>
                  </tr>
                  <tr>
                    <td>Köln</td>
                    <td>Flughafen Köln-Bonn, Fernbusterminal</td>
                    <td>22:15</td>
                    <td>25,- €</td>
                  </tr>
                  <tr>
                    <td>Frankfurt</td>
                    <td>Flughafen Terminal 1 | P36</td>
                    <td>00:45</td>
                    <td>0,- €</td>
                  </tr>
                </table>

                <!-- Hamburg Route -->
                <table class="mb-3">
                  <tr>
                    <th>Hamburg Route</th>
                    <th>Zustiegsort</th>
                    <th>Uhrzeit</th>
                    <th>Zuschlag</th>
                  </tr>
                  <tr>
                    <td class="pt-3">Hamburg</td>
                    <td class="pt-3">ZOB Harburg DB Bahnhof | Parkplatz P1B</td>
                    <td class="pt-3">17:30</td>
                    <td class="pt-3">+ 45,- €</td>
                  </tr>
                </table>

                <!-- Ostroute -->
                <table>
                  <tr>
                    <th>Ostroute</th>
                    <th>Zustiegsort</th>
                    <th>Uhrzeit</th>
                    <th>Zuschlag</th>
                  </tr>
                  <tr>
                    <td class="pt-3">Berlin</td>
                    <td class="pt-3">Straße des 17. Juni, ggü. TU-Haupteingang (Parkplatz vor dem Mathegebäude)</td>
                    <td class="pt-3">21:00</td>
                    <td class="pt-3">+ 45,- €</td>
                  </tr>
                  <tr>
                    <td>Leipzig</td>
                    <td>Flughafen Leipzig, Busparkplatz</td>
                    <td>22:45</td>
                    <td>+ 45,- €</td>
                  </tr>
                </table>

                <p class="mt-2">
                  <small>
                    Bei allen SCOL Zielen fallen auf der Nordroute keine
                    Zuschläge an.
                  </small>
                </p>
              </div>
              <div class="col-md-6 order-3 oder-md-4 pt-md-5">
                <p>
                  Unser SCOL Bus fährt immer auf der Nordroute ohne Zuschläge ab Oldenburg via Hannover in die Alpen. Die anderen Routen werden teilweise durch Reisepartner bedient. Die jeweiligen Abfahrtszeiten und genauen Zustiegsorte findet ihr in den jeweiligen Tabellen auf der linken Seite.
                </p>
                <br />
                <!-- <p>
                  <b>Zustiegsmöglichkeiten</b>: Damit ihr ohne Umwege in die
                  Alpen gelangen, erfolgen bei uns die Zustiege nur direkt an
                  der Strecke (in der Regel Autobahnraststätten).
                </p>
                <br />
                <p>
                  <b>Unser Reisepartner bedient die Westroute</b>: ab Münster
                  geht es hier via Ruhrgebiet Richtung Alpen. Voraussichtliche
                  Zustiegsorte sind Münster, Essen & Köln. Auf dieser Strecke
                  fallen teilweise Zuschläge an (Infos im Büro).
                </p> -->
                <!-- <br> -->
                <p>
                  <b>Zubringer zum Oldenburger Bahnhof</b><br>
                  Unser Shuttle-Service zum Oldenburger Bahnhof ab Wittmund, Jever, Sande oder Varel: für 20 € p. P. / auf Anfrage
                </p>
                <br>
                <p>
                  <b>Relax-Bestuhlung</b><br>
                  Noch größere Beinfreiheit und noch komfortableres Reisen, das bieten wir euch mit dieser Bestuhlung. Die Vorteile gegenüber dem normalen Fernreisebus:
                <ul>
                  <li>Größere Beinfreiheit: ca. 100 cm; zum Vergleich: Economy Class im Flugzeug: 76 cm</li>
                  <li>Rückenlehne bis zu 135 Grad zurückstellbar; zum Vergleich: Economy Flugzeug: 100 Grad / Es ist möglich, den Sitz in einen bequemen Schlafsessel zu verwandeln und eine „fast" liegende Position einzunehmen. Ihr habt die Wahl in diesen Bussen zwischen einem Super-Top-Premium-Class-Bussitzplatz, oder gegen einen geringen Aufpreis von nur <b>58,- €</b> für Hin-und Rückfahrt, dem beschriebenen Relax-Sessel.</li>
                </ul>
                Nordroute:
                Alle Ziele i. d. R. mit Relaxbestuhlung buchbar (Shorties ausgenommen)!
                Auf allen anderen Routen ist der Relax-Platz auf Anfrage buchbar!
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="tab-pane fade pt-4 pt-mt-5" id="bahn" role="tabpanel">
            <div class="row align-items-center">
              <div class="col-md-4">
                <img class="w-100" src="images/scol-skireisen-anreise-bahn.jpg" alt="SCOL Skireisen Urlaubsexpress Bahn" />
              </div>
              <div class="col-md-8 mt-4 mt-md-0">
                <h3>Anreise mit der Bahn: Euer Zug in den Schnee</h3>
                <p class="mb-4">
                  Im Liegewagen entspannt die Nacht verbringen und morgens
                  ausgeruht auf die Piste! Auf allen Verbindungen werden Snacks
                  und Getränke vom Bordservice angeboten. Es werden im Winter
                  zwei Strecken gefahren, der UEX Nord startet in Hamburg, der
                  UEX-West in Münster. Unsere Preisangaben beziehen sich auf
                  Plätze im 5er-/6er-Liegewagenabteil für Hin- und Rückreise bis
                  zum Zielbahnhof.
                  <strong>Der Transfer zur Unterkunft am Urlaubsort ist in Eigenregie
                    zu organisieren</strong>.
                </p>
                <p>
                  <strong>Transferhinweise Richtung Kals und Fügen:</strong>
                </p>
                <p>
                  <strong>Kals:</strong> Ab Kitzbühel fährt ein Postbus (Infos
                  auf postbus.at, Tickets im Bus) bis Huben (in Osttirol). Aus
                  Huben (noch ca. 10 Minuten bis Kals) holen wir euch vom Hotel
                  ab. Gruppen ab 8 Personen fragen gerne einen individuellen
                  Transfer ab Wörgl bei uns an.
                </p>
                <p>
                  <strong>Fügen:</strong> ab Jenbach nutzt ihr die Zillertalbahn
                  bis Haltestelle Fügen/Hart. Von dort sind es noch ca. 300 m
                  bis zum Hotel.
                </p>
              </div>
              <div class="col-12 mt-4 mt-lg-5">
                <h3>Urlaubsexpress <strong>NORDroute</strong> 2024</h3>
                <p>
                  <small>
                    <strong>Hinfahrt</strong> von Hamburg, Hbf. - St. Anton am
                    Arlberg / Zell am See
                  </small>
                </p>
                <div class="table-scrollable">
                  <table class="table-scrollable-mobile table-train-small">
                    <tr>
                      <th>ab</th>
                      <th>Fr. 20.12.24</th>
                      <th>Fr. 27.12.24</th>
                      <th>Fr. 24.01.25</th>
                      <th>Fr. 31.01.25</th>
                      <th>Fr. 07.02.25</th>
                      <th>Fr. 14.02.25</th>
                      <th>Fr. 21.02.25</th>
                      <th>Fr. 28.02.25</th>
                      <th>Fr. 07.03.25</th>
                      <th>Fr. 14.03.25</th>
                      <th>Fr. 21.03.25</th>
                    </tr>
                    <tr>
                      <td>Hamburg</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Bremen</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Hannover</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Berlin</td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="mt-4">
                  <small><strong>Rückfahrt</strong> von St. Anton am Arlberg / Zell
                    am See - Hamburg, Hbf.</small>
                </div>
                <div class="table-scrollable">
                  <table class="table-train-small">
                    <tr>
                      <th>ab</th>
                      <th>Sa. 21.12.24</th>
                      <th>Sa. 25.01.25</th>
                      <th>Sa. 01.02.25</th>
                      <th>Sa. 08.02.25</th>
                      <th>Sa. 15.02.25</th>
                      <th>Sa. 22.02.25</th>
                      <th>Sa. 01.03.25</th>
                      <th>Sa. 08.03.25</th>
                      <th>Sa. 15.03.25</th>
                      <th>Sa. 22.03.25</th>
                    </tr>
                    <tr>
                      <td>Berlin</td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Hannover</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-danger">
                          <i class="fas fa-times"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Bremen</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Hamburg</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

                <h3 class="mt-5">
                  Urlaubsexpress <strong>WESTroute</strong> 2024 / 2025
                </h3>
                <p>
                  <small>
                    <strong>Hinfahrt</strong> von Münster, Hbf. - St. Anton am
                    Arlberg / Zell am See
                  </small>
                </p>
                <div class="table-scrollable">
                  <table class="table-scrollable-mobile table-train-small">
                    <tr>
                      <th>ab</th>
                      <th>Fr. 27.12.24</th>
                      <th>Fr. 24.01.25</th>
                      <th>Fr. 07.02.25</th>
                      <th>Fr. 14.02.25</th>
                      <th>Fr. 21.02.25</th>
                      <th>Fr. 28.02.25</th>
                      <th>Fr. 14.03.25</th>
                      <th>Fr. 21.03.25</th>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Münster</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Essen</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Düsseldorf</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Köln Hbf.</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="mt-4">
                  <small><strong>Rückfahrt</strong> von St. Anton am Arlberg / Zell
                    am See - Münster, Hbf.</small>
                </div>
                <div class="table-scrollable">
                  <table class="table-scrollable-mobile table-train-small">
                    <tr>
                      <th>ab</th>
                      <th>Sa. 04.01.25</th>
                      <th>Sa. 01.02.25</th>
                      <th>Sa. 15.02.25</th>
                      <th>Sa. 22.02.25</th>
                      <th>Sa. 01.03.25</th>
                      <th>Sa. 08.03.25</th>
                      <th>Sa. 22.03.25</th>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Münster</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Essen</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Düsseldorf</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Münster</td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                      <td>
                        <div class="text-success">
                          <i class="fas fa-check"></i>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <h3 class="mt-5">Preise Urlaubsexpress</h3>
                <p>
                  <small>Mit unserem Partner Urlaubs-Express bieten wir die Anreise
                    mit dem Zug an.</small>
                </p>
                <div class="table-scrollable">
                  <table class="table-scrollable-mobile table-train-small">
                    <tr>
                      <th>Urlaubsziel (Zielbahnhof)</th>
                      <th>NS</th>
                      <th>HS (09.02.-15.03.24)</th>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">
                        Kals (Kitzbühel, Umstieg Wörgl)
                      </td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Fügen (Jenbach)</td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">Serfaus (Landeck)</td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">
                        Bad Hofgastein (Schwarzach/St. Veit, Um. Wörgl)
                      </td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">
                        Saalbach-Hinterglemm (Zell am See, Umst. Wörgl)
                      </td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">
                        Sölden/Obergurgl (Ötztal Bhf.)
                      </td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                    <tr>
                      <td style="max-width: 120px">
                        Kaltenbach-Ried (Jenbach)
                      </td>
                      <td>105 €</td>
                      <td>130 €</td>
                    </tr>
                  </table>
                </div>
                <p class="mt-4">
                  <small>
                    Preise verstehen sich pro Person im 5er/6er-Abteil<br />
                    Zuschläge 4er-Abteil: <b>40 € p. P. (auf Anfrage)</b><br />
                    Aufpreis 2er-Abteil: <b>140 € p. P. (auf Anfrage)</b><br />
                    <b>Kinderpreise:</b>
                    0 - 3 Jahre: kostenfrei (ohne Anspruch auf Liege)<br />
                    4 - 14 Jahre: 40 € Ermäßigung (vom Erwachsenenpreis)<br /><br />
                    Optional buchbar: Frühstück, zzgl. 8,90 € pro Person/Strecke
                    (Lunchbox & Heißgetränk)<br />
                    Hinweis: Änderungen bei Zustiegen, Fahrtzeiten und/oder
                    Plätzen behalten wir uns vor!
                  </small>
                </p>
              </div>

              <div class="col-lg-6 mt-4 mt-lg-5">
                <div class="bg-light p-4">
                  <h3>NIGHT Jet (NJ)</h3>
                  <p>
                    <small>
                      Mit dem Nachtzug der ÖBB kommt ihr entspannt über Nacht in
                      die Berge. Hoher Komfort ist garantiert, denn viele
                      Abteile sind ganz neu. Der Zug fährt täglich ab Hamburg
                      oder aus dem Ruhrgebiet Richtung Alpen und bietet Sitz-,
                      Liege- oder Schlafwagen an.
                      <br />
                      Mehr Infos zur Anreise, Preise usw. bekommt ihr bei uns im
                      Büro.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div> -->

          <div class="tab-pane fade pt-4 pt-mt-5" id="schneebus" role="tabpanel">
            <div class="row">
              <div class="col-md-6">
                <h3>Schneebus by SCOL</h3>
                <p>
                  <b>
                    Ihr wollt nur die Busfahrt in die Alpen buchen? - Kein
                    Problem!<br />
                  </b>
                  Unsere Busse starten jeweils am Freitagabend in die Alpen.
                  Termine und Ziele sind mit unseren normalen Reiseterminen
                  kompatibel, also vom 18.12. - 26.03.2027 könnt ihr unseren
                  Service nutzen. Die Rückfahrt erfolgt in der Regel am
                  Samstagabend. Mehr Infos zur Busanreise gibt es hier!
                </p>
                <p>
                  Es sind ausschließlich Ziele aus unserem Programm buchbar, die
                  Buchung erfolgt vorbehaltlich der möglichen Kapazitäten.
                  Weitere Ziele fragt bitte bei uns an.
                </p>
                <br />
                <p>
                  Der Preis pro Person für Hin- und Rückfahrt beträgt<br />
                  <b>320 € (Österreich)</b><br />
                  <b>370 € (Italien)</b>
                </p>
                <a class="btn btn-outline-primary rounded-pill my-4" href="kontakt">
                  <i class="far fa-calendar-check"></i> Anfragen
                </a>
              </div>
              <div class="col-md-6">
                <h3>B&B - Bus und Betreuung</h3>
                <p>
                  Du hast deine Lieblingsunterkunft, willst aber trotzdem
                  Gruppenfeeling? Dann buch doch unser 'B&B': Hin- und Rückfahrt
                  mit dem Bus und Betreuung vor Ort (Skiguiding und
                  Rahmenprogramm, z. T. gegen Gebühr). (B&B gilt nur für
                  SCOL-Ziele)
                </p>
                <p>
                  Pro Person für sagenhafte <b>385 € (Österreich)</b> bzw.
                  <b>420 € (Italien)</b>!
                </p>
                <br />
                <p>
                  Mehr Infos auch unter
                  <a href="tel:+49443596000"> 04435-96000</a>
                  !
                </p>
              </div>
            </div>
          </div>

          <div class="tab-pane fade pt-4 pt-mt-5" id="pkw" role="tabpanel">
            <h3>Die Anreise mit dem eigenen PKW: Die individuelle Lösung</h3>
            <div class="row">
              <div class="col-md-6">
                <p>
                  Gern könnt ihr mit dem eigenen PKW anreisen. Der Reisepreis
                  verringert sich um 50,- € pro Person.
                </p>
                <p>
                  Bei den Reisen nach
                  <b>Kals & Fügen</b> verringert sich der Preis sogar um
                  <b>100,- € pro Person</b>. In unserem Reisekatalog sind immer
                  die Termine für die Busreise ausgeschrieben. Die Busse starten
                  in der Regel am Freitagabend zu ihrer Nachtfahrt und erreichen
                  den Urlaubsort am nächsten Morgen...
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Der An- und Abreisetag am Urlaubsort ist in der Regel der
                  Samstag. Ihr habt also jeweils 7 Übernachtungen vor Ort. Bitte
                  teilt uns bei der Buchung mit, ob ihr mit dem PKW anreisen
                  wollt.
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="tab-pane fade pt-4 pt-mt-5" id="abreise" role="tabpanel">
            <div class="row">
              <div class="col-md-4">
                <img class="w-100" src="images/scol-skireisen-anreise-bus.jpg" alt="Bus von Janssen Reisen" />
              </div>
              <div class="col-md-8 mt-4">
                <h3>Die wichtigsten Infos für unsere Abreisen</h3>
                <p>
                  Auf der Nordroute fahren wir (OL-HB-H) wieder mit den Top
                  Premium ClassFernreisebussen u.a. der Firmen Janssen und
                  Hilgen. Diese Busse bieten Ihnen ein Maximum an Freiraum und
                  Bequemlichkeit. Sie bieten einen vergleichbaren Sitzabstand zu
                  ****/*****-Bussen. Dieser beträgt mind. 15 cm mehr als in
                  anderen Standard Class Bussen. Die Busse (Nichtraucher) sind
                  mit WC, Liegesessel, Kühlschrank und teilweise mit Bordbistro
                  ausgestattet. Bordkomfort bis ins kleinste Detail macht jede
                  lange Reise zu einem kurzweiligen Vergnügen.
                </p>
              </div>
              <div class="col-lg-6 mt-4 mt-lg-5">
                <p>
                  Bitte informiert euch unbedingt vor eurer Reise über die vor
                  Ort geltenden Regeln. Mehr dazu findet ihr hier:
                </p>
                <p>
                  <b>Österreich</b>:
                  <a href="https://www.tirol.at/reiseservice/anreise" target="_blank">willkommen.tirol</a>
                  bzw.
                  <a href="https://www.bmaw.gv.at/Themen/Tourismus/Sichere-Gastfreundschaft.html" target="_blank">sichere-gastfreundschaft.at</a>
                </p>
                <p>
                  <b>Italien</b>:
                  <a href="https://www.suedtirol.info/de/informationen/coronavirus/anreise" target="_blank">suedtirol.info</a>
                </p>
                <br />
                <p>
                  In der Regel starten unsere Busse am Freitagabend Richtung
                  Alpen (das erste Datum in unseren Terminen ist immer der
                  Abreisetag des Busses).
                </p>
                <p>
                  Für den Fall, dass irgendetwas nicht funktioniert kontaktiert
                  bitte unsere SCOL Notfallnummer:
                  <a href="tel:+491724296010"> 0172-4296010</a><br />
                  <b>Zustiegsorte und Abfahrzeiten (Änderungen vorbehalten):</b>
                </p>
                <div class="table-scrollable">
                  <table class="mt-4 table-scrollable-mobile">
                    <tr>
                      <th>Nordroute</th>
                      <th>Abfahrtzeit</th>
                      <th>Adresse</th>
                    </tr>
                    <tr>
                      <td>Oldenburg</td>
                      <td>20:00</td>
                      <td>ZOB Karlstraße<br />26123 Oldenburg</td>
                    </tr>
                    <tr>
                      <td>Bremen (Hemelingen)</td>
                      <td>ca. 20:45</td>
                      <td>
                        Autohof Bremen Hemelingen<br />Europaallee 1-3<br />D-28309
                        Bremen
                      </td>
                    </tr>
                    <tr>
                      <td>Hannover (Rast. Wülferode)</td>
                      <td>ca. 22:00</td>
                      <td>
                        Raststätte Hannover Wülferode West A7<br />30539
                        Hannover<br /><span class="text-danger">Hinweis: Halt an der Tankstelle.</span>
                        Hannover<br /><span class="text-danger">Hinweis: Halt an der Tankstelle.</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Göttingen</td>
                      <td>ca. 23:00</td>
                      <td>
                        Raststätte Göttingen West Autobahngelände<br />37124
                        Rosdorf<br /><span class="text-danger">Hinweis: Halt an der Tankstelle.</span>
                        Rosdorf<br /><span class="text-danger">Hinweis: Halt an der Tankstelle.</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Kassel</td>
                      <td>ca. 00:15</td>
                      <td>
                        Rastplatz Kassel Ost A7 (Axxe Motel)<br />34253
                        Lohfelden<br /><span class="text-danger">Hinweis: Halt an der Tankstelle.</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="col-lg-6 mt-4 mt-lg-5">
                <h3>Selbstfahrer/ eigene Anreise</h3>
                <p>
                  Bitte beachtet als Selbstfahrer den <b>Anreisetag</b>. Das
                  Reisedatum in der Bestätigung/ dem Katalog/ Internet bezieht
                  sich immer auf den Abreisetag bei Busanreise ab Oldenburg.
                  Somit gilt für die eigene Anreise einen Tag später.
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="bg-light scol-section">
        <div class="container">
          <div class="row">
            <div class="col-md-8">
              <h2>Wichtige Info</h2>
              <p>
                Bitte informiert euch unbedingt vor eurer Reise über die vor Ort
                geltenden Regeln.
              </p>
              <p>
                Mehr dazu findet ihr hier: Österreich:
                <a href="https://www.willkommen.tirol/" target="_blank">willkommen.tirol</a>
                bzw. Italien:
                <a href="https://www.bmaw.gv.at/Themen/Tourismus/Sichere-Gastfreundschaft.html" target="_blank">sichere-gastfreundschaft.at</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>



<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
  mounted() {
    var hash = window.location.hash.substr(1);
    if (document.querySelectorAll("[data-bs-target='#" + hash + "']")[0]) {
      setTimeout(function () {
        document
          .querySelectorAll("[data-bs-target='#" + hash + "']")[0]
          .click();
      }, 500);
    }
  },
};
</script>
